@if (!isCompleted()) {
    <matchmaking-form-step-header-wrapper
        [title]="currentStepContent()!.title"
        [description]="currentStepContent()!.description"
        [step]="+currentStepContent()!.stepCount"
        [lastStep]="currentStepName() === MATCHMAKING_STEPS.preview" />
    @switch (currentStepName()) {
        @case (MATCHMAKING_STEPS.industry) {
            <matchmaking-step-industry [content]="currentStepContent()!" />
        }
        @case (MATCHMAKING_STEPS.application) {
            <matchmaking-step-application [content]="currentStepContent()!" />
        }
        @case (MATCHMAKING_STEPS.application_specific) {
            <matchmaking-step-application-specific [content]="currentStepContent()!" />
        }
        @case (MATCHMAKING_STEPS.project) {
            <matchmaking-step-project [content]="currentStepContent()!" />
        }
        @case (MATCHMAKING_STEPS.preview) {
            <matchmaking-step-preview
                [content]="currentStepContent()!"
                [caseStories]="formContent().config?.caseStories"
                [videos]="formContent().config?.videos"
                [form]="config.content.form" />
        }
    }
} @else {
    <matchmaking-result-page
        [webinarsForYouContent]="config.content.webinarsForYouFeature"
        [academyTrainingContent]="config.content.academyTrainingFeature"
        [caseStories]="formContent().config?.caseStories"
        [blogs]="formContent().config?.blogs"
        [products]="formContent().config?.products"
        [ebooks]="formContent().config?.ebooks">
    </matchmaking-result-page>
}
